import { LoginPageModule } from './../../../public/login/login.module';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DeleteAccountConfirmationPageRoutingModule } from './delete-account-confirmation-routing.module';

import { DeleteAccountConfirmationPage } from './delete-account-confirmation.page';
import { LoginPage } from 'src/app/pages/public/login/login.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DeleteAccountConfirmationPageRoutingModule,
    ComponentsModule,
    ReactiveFormsModule,
    NgCircleProgressModule.forRoot({
      radius: 80,
      space: -10,
      titleFontSize: "14",
      outerStrokeColor: "#0F243B",
      innerStrokeColor: "#e7e8ea",
      outerStrokeWidth: 10,
      innerStrokeWidth: 10,
      animationDuration: 300,
      showImage: false,
      showSubtitle: false,
      showUnits: false,
    }),
    LoginPageModule
  ],
  declarations: [DeleteAccountConfirmationPage]
})
export class DeleteAccountConfirmationPageModule {}
